
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"4","viewBox":"0 0 24 4","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.5 3.448H22.5C22.8978 3.448 23.2794 3.28996 23.5607 3.00866C23.842 2.72735 24 2.34582 24 1.948C24 1.55017 23.842 1.16864 23.5607 0.887338C23.2794 0.606033 22.8978 0.447998 22.5 0.447998H1.5C1.10218 0.447998 0.720644 0.606033 0.43934 0.887338C0.158035 1.16864 0 1.55017 0 1.948C0 2.34582 0.158035 2.72735 0.43934 3.00866C0.720644 3.28996 1.10218 3.448 1.5 3.448Z","fill":"currentColor"}})])
          )
        }
      }
    